import van from "vanjs-core";
import {DateAndTimeFooter} from "../../components/date-and-time";
import {SmallTagWithDescriptions} from "../../components/small-tag-with-description";
import {Logos} from "../../components/logos";
import {temperature, nominalPower, areaPlant} from "../../state-variables";
import {getSum} from "../../tools/tools";

const {div, span, img} = van.tags;

// Footer
export const Footer = () => {
    return div({class: "footer d-flex flex-row align-items-center mt-auto justify-content-between"},
        div({class: "reactive-displays"},
            DateAndTimeFooter,
            SmallTagWithDescriptions("Venkovní teplota", "Ambient Temperature", temperature, "°C"),
            SmallTagWithDescriptions("Jmenovitý výkon", "Nominal power", ({val: getSum(nominalPower.val)}), "kWp"),
            SmallTagWithDescriptions("Osazená plocha", "Area plant", ({val: getSum(areaPlant.val)}), "m2"),
        ),
        Logos,
    )
}